import { CatalogTable, CatalogTableColumnsFunc } from '@backstage/plugin-catalog';
import { OverflowTooltip } from '@backstage/core-components';

export const createCatalogPageColumns: CatalogTableColumnsFunc = entityListContext => {
  if (entityListContext.filters.kind?.value === 'system' || entityListContext.filters.kind?.value === 'component') {
    return [
      CatalogTable.columns.createNameColumn(),
      CatalogTable.columns.createOwnerColumn(),
      CatalogTable.columns.createMetadataDescriptionColumn(),
      {
        title: 'Tier',
        field: 'entity.spec.criticality.tier',
        render: ({ entity }) => (
          <OverflowTooltip
            text={String((entity.spec?.criticality as { tier: number })?.tier ?? 'N/A')}
            placement="top"
          />
        ),
        width: '100',
      },
      CatalogTable.columns.createTagsColumn(),
    ];
  }

  return CatalogTable.defaultColumnsFunc(entityListContext);
};
